module.exports = __webpack_public_path__ + "img/couples_07_V.965a4766.webp";